import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from "@env/environment";
import { AuthSessionService } from '@services/auth-session.service';
import { HttpServiceUtil } from './laravel/http-service-util';

@Injectable({
  providedIn: 'root'
})
export class MatrixService { 
  url = environment.urlToApi + 'sisbia/';

  constructor(private http: HttpClient, private authSession: AuthSessionService) {}

  get = (route) => new Promise((resolve, reject) => {
    this.http.get(this.url + this.mapRoute(route), HttpServiceUtil.setHeaders(this.authSession))
    .subscribe(res => resolve(res), (rej: any) => reject(rej));
  });

  post = (route, data) => new Promise((resolve, reject) => {
    this.http.post(this.url + this.mapRoute(route), data, HttpServiceUtil.setHeaders(this.authSession))
    .subscribe(res => resolve(res), (rej: any) => reject(rej));
  });

  private mapRoute(route: string): string {
    if (route.startsWith('matrices/no-tree/')) {
      return route.replace('matrices/no-tree/', 'get-matrix-by-id/');
    }

    if (route === 'matrices-with-itinerarie') {
      return 'filter-matrices';
    }

    return route;
  }
}
